import { formatDateOnly } from './format';
import type { DealQuoteSigned } from './types';

/**
 * "Quote signed" on a deal (owner 2026-10-27). The server derives it: the deal's
 * linked quote currently on an accepted stage (flags, never names). One copy of
 * the label and wording for the deals list, deal detail, kanban, UP dashboard and
 * sales tracker.
 *
 * `undefined` = an older API (render nothing), `null` = not signed (render `—`).
 */

export const QUOTE_SIGNED_LABEL = 'Quote signed';

export const QUOTE_SIGNED_FILTER_OPTIONS = [
  { value: 'signed', label: 'Signed' },
  { value: 'unsigned', label: 'Not signed' },
] as const;

export type QuoteSignedFilter = (typeof QUOTE_SIGNED_FILTER_OPTIONS)[number]['value'];

/** "Signed 12 Oct 2026", "Signed" when the date is unknown, `—` when not signed. */
export function quoteSignedLabel(signed: DealQuoteSigned | null | undefined): string {
  if (signed === undefined || signed === null) return '—';
  if (signed.signedAt === null) return 'Signed';
  return `Signed ${formatDateOnly(signed.signedAt.slice(0, 10))}`;
}

/** The signed date alone (`—` when unknown or not signed), for compact cells. */
export function quoteSignedDate(signed: DealQuoteSigned | null | undefined): string {
  if (signed === undefined || signed === null || signed.signedAt === null) return '—';
  return formatDateOnly(signed.signedAt.slice(0, 10));
}
